import React from "react";
import PropTypes from "prop-types";
import "../CustomerPreview.scss";
import { Divider } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ReferrerDetails = ({ applicantData, enquiryDetails }) => {
  const { t } = useTranslation("common");
    
  return (
    <div className="kycDocument purvaPrivilege">
      <div className="applicantDetailsCard">
        <h3 className="titlePersonalHD marginBottom16">{`${
          enquiryDetails?.data?.projectBrandName === null
            ? "" 
            : enquiryDetails?.data?.projectBrandName === "Provident" ? "Provident Premier" : "Purva Privilege​"
        }`}</h3>
        <div className="privilege">
          {t("referrerDetails.pleaseRead")},
          <ol>
            {t("referrerDetails.instructions", { returnObjects: true })?.map(
              (item, index) => (
                <li key={item || index}>{item}</li>
              )
            )}
          </ol>
        </div>
        <Divider sx={{ border: '1px dashed #D6D6D6', mb: 2, mt: 2 }} />
        <h3 className="titlePersonalHD marginBottom16">{t("referrerDetails.title")}</h3>
        <div className="personalInfo ReferrerPrivilege">
          <div className="personalInfoRow">
            <p className="label180">{t("referrerDetails.labels.name")}:</p>
            <span>
              {applicantData?.referrerDetails?.name
                ? applicantData?.referrerDetails?.name
                : "N/A"}
            </span>
          </div>
          <div className="personalInfoRow">
            <p className="label200">{t("referrerDetails.labels.relation")}:</p>
            <span>
              {applicantData?.referrerDetails?.relation
                ? applicantData?.referrerDetails?.relation
                : "N/A"}
            </span>
          </div>
          <div className="personalInfoRow">
            <p className="label180">{t("referrerDetails.labels.propertyName")}:</p>
            <span>
              {applicantData?.referrerDetails?.propertyName
                ? applicantData?.referrerDetails?.propertyName
                : "N/A"}
            </span>
          </div>
          <div className="personalInfoRow">
            <p className="label200">{t("unitDetails.labels.unitNumber")}:</p>
            <span>
              {applicantData?.referrerDetails?.unitNumber
                ? applicantData?.referrerDetails?.unitNumber
                : "N/A"}
            </span>
          </div>
          <div className="personalInfoRow">
            <p className="label180">{t("commonLabels.contactNumber")}:</p>
            <span>
              {applicantData?.referrerDetails?.mobileNumber
                ? `${applicantData?.referrerDetails?.countryCode} ${applicantData?.referrerDetails?.mobileNumber}`
                : "N/A"}
            </span>
          </div>
          <div className="personalInfoRow">
            <p className="label200">{t("commonLabels.emailAddress")}:</p>
            <span>
              {applicantData?.referrerDetails?.email
                ? applicantData?.referrerDetails?.email
                : "N/A"}
            </span>
          </div>
          
          <div className="personalInfoRow">
            <p className="label180">{t("referrerDetails.labels.houseNumber")}:</p>
            <span>
              {applicantData?.referrerDetails?.houseNumber
                ? applicantData?.referrerDetails?.houseNumber
                : "N/A"}
            </span>
          </div>
        </div>
        <div className="personalInfoRow">
            <p className="label180">{t("referrerDetails.labels.address")}:</p>
            <span>
              {applicantData?.referrerDetails?.address
                ? applicantData?.referrerDetails?.address
                : "N/A"}
            </span>
          </div>
      </div>
    </div>
  );
};



ReferrerDetails.propTypes = {
  applicantData: PropTypes.object,
  enquiryDetails: PropTypes.any,
};
